import React from 'react';
import { Button, Modal, ModalBody, Image, Row, Col } from 'react-bootstrap';
import { ConvertDate } from '../../../../Helpers/formatDate';
import FormatMoney from '../../../../Helpers/formatMoney';

import DepositIcon from '../../../../Images/deposito.svg';
import CompraIcon from '../../../../Images/compra.svg';
import SalirIcon from '../../../../Images/salir.svg';
import './modal.css';


export const ModalDetails = ({show, handleClose, ...props}) => {
  let date = ConvertDate(props.item?.date?.substr(0,10))
  let time = props.item?.date?.substr(11,15).slice(0, -3)

  return(
    <Modal id="modal-details" show={show} onHide={handleClose} size="sm" aria-labelledby="test">
      <Modal.Header className='custom-header' >
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '-60px'}}>
          <Image src={SalirIcon} onClick={handleClose} alt="X" style={{cursor: 'pointer'}}/>
        </div>
        <div style={{position: 'absolute', width: '93%', textAlign: 'center'}}>
          <Modal.Title className="" >{props.traductions.Card.enabled.modalTransaction.title}</Modal.Title>
        </div>
      </Modal.Header>

      <div style={{textAlign: 'center', position: 'relative', marginTop: '-25px'}}>
        <Image src={props.item.type === 'deposit' ? DepositIcon : CompraIcon} width={52} height={52}/>
      </div>
      <ModalBody style={{padding: '35px 70px'}}>
        <div className='wrapper-price'>
          <div className='description-title'>
            {props.item.description}
          </div>
          <div className='amount-title'>{props.item.type !== 'deposit' && '-'}{FormatMoney(props.item.amount)}</div>
          <div className='date-title'>{date}, {time}</div>
        </div>
        <div style={{marginBottom: 17}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_organization}</span>
          <div>{props.item.organization}</div>
        </div>


        <div style={{marginBottom: 17}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_withdrawal_account}</span>
          <div className='info'>*{props.item.account}</div>
        </div>
        <div style={{marginBottom: 17}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_amount}</span>
          <div>{props.item.type !== 'deposit' && '-'}{FormatMoney(props.item.amount)}</div>
        </div>
        <div style={{marginBottom: 17}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_movement_type}</span>
          <div>{props.item.type}</div>
        </div>
        <div style={{marginBottom: 17}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_concept}</span>
          <div>{props.item.description}</div>
        </div>
        {
          props?.item?.commerce !== '' &&
          <div>
            <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_commerce}</span>
            <div>{props.item.commerce}</div>
          </div>
        }
        <div style={{marginBottom: 33}}>
          <span className='label-gray'>{props.traductions.Card.enabled.modalTransaction.L_reference_number}</span>
          <div>{props.item.reference}</div>
        </div>
        <div style={{textAlign: 'center'}}>
          <Button onClick={props.showUnrecognizedModal} className='btn-detail'>{props.traductions.Card.enabled.modalTransaction.L_unrecognized}</Button>
        </div>
      </ModalBody>
    </Modal>
  )
}